export default class Filter {
  constructor() {
    this.select = document.querySelector('select.select');
    this.cards = document.querySelectorAll('.js-card');
    this.blogContainer = document.querySelector('.js-blog-wrapper');
    this.loadMoreButton = document.querySelector('.js-load-more');
    this.totalItems = this.blogContainer.dataset.total;
    this.numberOfNewItems = 12;

    this.loadMoreButton.addEventListener('click', () => {
      // eslint-disable-next-line compat/compat
      fetch(`${window.location}/items?limit=${this.numberOfNewItems}&skip=${this.numberOfNewItems}`)
        .then((response) => response.text())
        // eslint-disable-next-line no-return-assign
        .then((data) => {
          this.blogContainer.innerHTML += data;
          this.cards = document.querySelectorAll('.js-card');
          if (this.cards.length >= this.totalItems) {
            this.loadMoreButton.classList.add('visuallyhidden');
          }
          this.numberOfNewItems += 12;
        });
    });
    this.select.addEventListener('change', () => {
      for (let i = 0; i < this.cards.length; i++) {
        if (this.cards[i].dataset.category !== this.select.value) {
          this.cards[i].classList.add('visuallyhidden');
        } else {
          this.cards[i].classList.remove('visuallyhidden');
        }

        if (this.select.value === 'all') {
          this.cards[i].classList.remove('visuallyhidden');
        }
      }
    });
  }
}
